import React, { useEffect, useState, Dispatch } from 'react';
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Tooltip,
  notification,
} from 'antd';
import { CloseOutlined, PlusCircleOutlined, SaveOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2';
import { CriarCadVeiculoService, getVeiculos } from '../services/cadVeiculoServices';
import moment from 'moment';
import { ApplicationState } from '../../../../store';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../../store/ducks/listarVeiculos/actions';
import TextFilter from '../../../../components/TextFilter';
import TitlePage from '../../../../components/TitlePage';
import { selectTransportadoraParceiraRequest } from '../../../../store/ducks/transportadoras/actions';
import { placaValidation } from 'utils/validator';

const ModalVeiculo: React.FC = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<Dispatch<Action>>();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);

  useEffect(() => {
    try {
      getVeiculos.getTipoVeiculos();
    } catch (error) {
      Swal.fire({
        title: 'Não foi possivel carregar a lista de veículos, por favor tente novamente!',
        html: '',
        icon: 'warning',
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }, []);

  useEffect(() => {
    try {
      dispatch(selectTransportadoraParceiraRequest(cddAtivo?.codCdd as number, inscricaoAtiva));
    } catch (error) {
      Swal.fire({
        title: 'Não foi possivel carregar a lista de transportadoras, por favor tente novamente!',
        html: '',
        icon: 'warning',
        showConfirmButton: true,
      });
    }
  }, [inscricaoAtiva, cddAtivo?.codCdd, dispatch]);

  const disabledDate = (current: any) => {
    return current && moment(current).format() < moment().format('1900-01-01');
  };

  const onFinish = async (values: any) => {
    const isValide = placaValidation(values.placa);

    if (!isValide) {
      return notification.error({
        message: 'Placa inválida',
        placement: 'bottomRight',
      });
    }

    const veiculo = {
      codParcTransp: values.codParcTransp as number,
      placa: values.placa as string,
      ano: values?.ano && Number(moment(values?.ano).format('YYYY')),
    };

    try {
      await CriarCadVeiculoService.criaAlteraVeiculoPortal(veiculo, inscricaoAtiva).then((res) => {
        Swal.fire({
          title: 'Veículo cadastrado com sucesso!',
          html: '',
          icon: 'success',
          showConfirmButton: false,
          timer: 1500,
        });
      });
      dispatch(loadRequest(inscricaoAtiva));
      setIsModalVisible(false);
      form.resetFields();
    } catch (error: any) {
      if (error.response.data.Erro) {
        return notification.error({
          message: error.response.data.Erro,
          placement: 'bottomRight',
        });
      }
      return notification.error({
        message: 'Não foi possível cadastrar o veículo, tente novamente ou contate o suporte.',
        placement: 'bottomRight',
      });
    }
  };

  const oncancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  return (
    <>
      <Modal
        centered
        title={<TitlePage> Cadastro de veículos</TitlePage>}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        maskClosable={true}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={850}
        footer={[]}
      >
        <Form form={form} onFinish={onFinish}>
          <Row gutter={24}>
            <Col md={8} sm={24} xs={24}>
              <Form.Item
                style={{ display: 'table', width: '100%' }}
                name="placa"
                label={<TextFilter>Placa do veículo</TextFilter>}
                rules={[{ required: true, message: 'Digite a Placa do veículo' }]}
              >
                <Input type="text" min={0} maxLength={7} style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col md={8} sm={24} xs={24}>
              <Form.Item
                style={{ display: 'table', width: '100%' }}
                name="ano"
                label={<TextFilter>Ano de fabricação</TextFilter>}
                // rules={[{ required: true, message: 'Digite o ano do veículo' }]}
              >
                <DatePicker
                  onChange={(date: any, dateString: any) => {}}
                  disabledDate={disabledDate}
                  style={{ width: '100%' }}
                  picker="year"
                />
              </Form.Item>
            </Col>
          </Row>

          <Col style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
            <Space>
              <Button type="default" onClick={oncancel} icon={<CloseOutlined />}>
                Cancelar
              </Button>
              <Button
                data-cy="btn-confirmar-veiculo"
                type="primary"
                htmlType="submit"
                icon={<SaveOutlined />}
              >
                cadastrar
              </Button>
            </Space>
          </Col>
        </Form>
      </Modal>
      <Tooltip title={inscricaoAtiva.length > 0 ? '' : 'Por favor insira o CD e o(s) parceiro(s)'}>
        <Button
          data-cy="btn-novo-veiculo"
          style={{
            width: '100%',
          }}
          onClick={() => setIsModalVisible(true)}
          icon={<PlusCircleOutlined />}
          disabled={inscricaoAtiva.length > 0 ? false : true}
        >
          Novo Cadastro
        </Button>
      </Tooltip>
    </>
  );
};

export default ModalVeiculo;
